"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _WebmasterCandidate = _interopRequireDefault(require("./WebmasterCandidate"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmailManager = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmailManager, _Component);

  var _super = _createSuper(EmailManager);

  function EmailManager(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmailManager);
    _this = _super.call(this, props);
    _this.state = {
      emails: props.emails ? props.emails : []
    };
    return _this;
  }

  (0, _createClass2.default)(EmailManager, [{
    key: "deleteEmail",
    value: function deleteEmail(email) {
      this.setState({
        emails: this.state.emails.filter(function (e) {
          return e !== email;
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return state.emails.length > 0 || props.type === 'verification' ? (0, _preact.h)("div", {
        className: 'emails-' + props.type
      }, (0, _preact.h)("h3", null, props.title), (0, _preact.h)("div", {
        className: "alert"
      }, props.tip), state.emails.length > 0 ? state.emails.map(function (e) {
        return (0, _preact.h)(_WebmasterCandidate.default, {
          key: e,
          email: e,
          showSendButton: props.type !== 'success',
          showDeleteButton: true,
          onDelete: function onDelete() {
            return _this2.deleteEmail(e);
          }
        });
      }) : (0, _preact.h)(_WebmasterCandidate.default, {
        email: "",
        showSendButton: true
      })) : null;
    }
  }]);
  return EmailManager;
}(_preact.Component);

var _default = EmailManager;
exports.default = _default;